import { FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { addMonths, format, setDate, subDays } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { usePayPerUseExtraTruckers } from 'hooks/usePayPerUseExtraTruckers';
import React from 'react';

const ConsumptionLabel = () => {
  const { extraConsumption, freeAvailable, renewalDay, isFreeAvailableEmpty } = usePayPerUseExtraTruckers();

  const showExpiryDate = renewalDay && !isFreeAvailableEmpty;

  const getFormattedExpiryDate = () => {
    const today = new Date();
    let renewalDate = setDate(today, renewalDay);

    if (renewalDate.getDate() - 1 < today.getDate()) {
      renewalDate = addMonths(renewalDate, 1);
    }

    renewalDate = subDays(renewalDate, 1);

    return `Pacote válido até ${format(renewalDate, 'dd/MM', { locale: ptBR })}`;
  };

  const getConsumptionLabel = () => {
    if (extraConsumption > 0) {
      const acquired = extraConsumption === 1 ? 'adquirido' : 'adquiridos';
      return `${extraConsumption} ${acquired} neste mês`;
    }

    const freeAvailableLabel = freeAvailable === 1 ? 'disponível na degustação' : 'disponíveis na degustação';

    return isFreeAvailableEmpty ? 'Nenhum adquirido neste mês' : `${freeAvailable} ${freeAvailableLabel}`;
  };

  return (
    <FuelFlex>
      <FuelTypography size="caption" weight="medium" color="neutral-default">
        {getConsumptionLabel()}
      </FuelTypography>
      {isFreeAvailableEmpty && (
        <FuelTypography size="caption" weight="medium" color="neutral-default">
          &nbsp;| Preço promocional
        </FuelTypography>
      )}
      {showExpiryDate && (
        <FuelTypography size="caption" weight="medium" color="neutral-default">
          &nbsp;| {getFormattedExpiryDate()}
        </FuelTypography>
      )}
    </FuelFlex>
  );
};

export default ConsumptionLabel;
